// extracted by mini-css-extract-plugin
export var videoWrapper = "landing-video-module--video-wrapper--7XMDH";
export var video = "landing-video-module--video--IzILC";
export var videoInnerWrapper = "landing-video-module--video-inner-wrapper--8YNkq";
export var videoFrame = "landing-video-module--video-frame--rYPdB";
export var maskOverlay = "landing-video-module--mask-overlay--2cQxC";
export var playButton = "landing-video-module--play-button--WIqQ5";
export var modalWrapper = "landing-video-module--modal-wrapper--SkDTu";
export var closeIcon = "landing-video-module--close-icon---XOyC";
export var modalVideoFrame = "landing-video-module--modal-video-frame--2x9+b";